<script>
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import Icon from '../icon/Icon.svelte';

    import { __ } from '@oat-sa-private/ui-core';
    const skins = {
        primary: 'primary',
        info: 'info',
        dotted: 'dotted',
        grey: 'grey'
    };

    const targets = {
        blank: 'blank',
        self: 'self'
    };

    export let label = __('link');
    export let ariaLabel = false;
    export let skin = skins.primary;
    export let href = null;
    export let target = targets.blank;
    export let icon = false;
    export let iconSide = 'before';

    if (!skins[skin]) {
        skin = skins.primary;
    }
</script>

<style>
    a.link {
        text-decoration: none;
        display: inline-flex;

        &.after {
            flex-direction: row-reverse;
        }
    }

    a.link .icon-wrapper {
        line-height: 20px;
    }

    a.link :global(.icon-wrapper svg) {
        margin-bottom: var(--space-quarter);
    }

    .underlined-label {
        text-decoration: underline;
        margin-left: var(--space-1x);
        margin-right: var(--space-1x);
    }

    .link {
        @add-mixin outline-focus 0;
    }
</style>

<a class="link {skin} {iconSide}" target="_{target}" {href} aria-label={ariaLabel ? ariaLabel : label}>
    {#if icon}
        <span class="icon-wrapper"> <Icon name={icon} /></span>
    {/if}
    <span class="underlined-label">{label}</span>
</a>
